(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sfcjs"));
	else if(typeof define === 'function' && define.amd)
		define(["sfcjs"], factory);
	else if(typeof exports === 'object')
		exports["tdesign-sfc/t-button"] = factory(require("sfcjs"));
	else
		root["tdesign-sfc/t-button"] = factory(root["SFCJS"]);
})(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__674__) {
return 